import React from "react";
import msme from "../assets/images/msme.png";
import iso from "../assets/images/iso.png";
import skillIndia from "../assets/images/skill-india.png";

const CertificationsSection = () => {
  return (
    <section className="w-full bg-white py-4">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-10">

        {/* MSME */}
        <div className="w-48 h-48 flex items-center justify-center bg-white">
          <img src={msme} alt="MSME" className="max-h-full max-w-full object-contain" />
        </div>

        {/* ISO */}
        <div className="w-48 h-48 flex items-center justify-center bg-white">
          <img src={iso} alt="ISO" className="max-h-full max-w-full object-contain" />
        </div>

        {/* Skill India */}
        <div className="w-48 h-44 flex items-center justify-center bg-white">
          <img src={skillIndia} alt="Skill India" className="max-h-full max-w-full object-contain" />
        </div>

      </div>
    </section>
  );
};

export default CertificationsSection;
